import { useTheme } from "next-themes";
import { Moon, Sun } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return (
    <Button variant="ghost" size="icon" className="rounded-full" onClick={() => setTheme(dark ? "light" : "dark")} aria-label="Toggle theme" data-testid="theme-toggle-button">
      {dark ? <Sun size={18} /> : <Moon size={18} />}
    </Button>
  );
}
